import React, { useState, useEffect } from 'react';
import { Shield } from 'lucide-react';

const CONSENT_KEY = 'energipro_cookie_consent';

export const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-sm border-t border-slate-700 px-4 py-4 sm:px-6">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Shield className="w-5 h-5 text-orange-400 mt-0.5 shrink-0" />
          <p className="text-slate-300 text-sm leading-relaxed">
            We use essential cookies to ensure the website functions correctly. 
            By continuing to use this site, you consent to the use of cookies. 
            For more information, review our{' '}
            <a href="/privacy" className="text-orange-400 hover:text-orange-300 underline">
              Privacy Policy
            </a>.
          </p>
        </div>
        <button
          onClick={accept}
          className="shrink-0 px-6 py-2 bg-orange-600 hover:bg-orange-700 text-white text-sm font-bold rounded-sm transition-colors duration-200"
        >
          Accept
        </button>
      </div>
    </div>
  );
};
